
export default (props) => {

    return (
        <svg
            width={props.width}
            height={props.height}
            viewBox="0 10.667 141.833 99.667"
            xmlSpace="preserve"
            {...props}
        >
            <g fill={props.color}>
                <path d="m140.38 12.29-64.17 96.17h-.19l-8.56-12.78 54.92-83.39zM118.71 12.29 65.26 92.4l-8.73-13.02 44.18-67.09z" />
                <path d="m67.46 95.68 8.56 12.78H59.04zM67.46 95.68l-8.42 12.78h-1.02l-1.75-2.6 8.99-13.46z" />
                <path d="m56.53 79.38 8.73 13.02-8.99 13.46-8.68-12.9z" />
                <path d="m41.85 57.46 14.68 21.92-8.94 13.58-23.9-35.5zM56.27 105.86l-1.73 2.6h-.19l-8.56-12.78 1.8-2.72zM45.79 95.68l8.56 12.78H37.38zM45.79 95.68l-8.41 12.78h-1.03l-34.33-51h18.17z" />
            </g>
            <g fill="none">
                <path d="M59.04 108.46h-1.02l-1.75-2.6M65.26 92.4l2.2 3.28M47.59 92.96l-23.9-35.5h18.16l14.68 21.92M67.46 95.68l54.92-83.39h18l-64.17 96.17H59.04zM37.38 108.46h-1.03l-34.33-51h18.17l25.6 38.22" />
                <path d="m56.53 79.38 44.18-67.09h18L65.26 92.4l-8.99 13.46-1.73 2.6H37.38l8.41-12.78 1.8-2.72z" />
            </g>
        </svg>
    )
};